import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Form } from 'antd';
import { Select } from 'ui/styled';
import LabeledTooltip from '../LabeledTooltip';
var LocationSelect = function (_a) {
    var entity = _a.entity, loading = _a.loading, isLocationDisabled = _a.isLocationDisabled, _b = _a.label, label = _b === void 0 ? 'Covered Location' : _b;
    var locations = ((entity === null || entity === void 0 ? void 0 : entity.addresses) || []).map(function (_a) {
        var _b = _a.address, address = _b === void 0 ? '' : _b, _c = _a.phone, phone = _c === void 0 ? '' : _c, _d = _a.uuid, uuid = _d === void 0 ? '' : _d;
        return ({
            label: "".concat(address).concat(phone ? " / ".concat(phone) : ''),
            value: uuid
        });
    });
    return (_jsx(Form.Item, { name: "location_uuid", rules: [
            {
                required: !isLocationDisabled,
                message: 'Select a location to attach to this provider.'
            }
        ], label: _jsx(LabeledTooltip, { label: label }), labelAlign: "left", colon: false, children: _jsx(Select, { placeholder: "Select location based on plan", loading: loading, disabled: isLocationDisabled, options: locations }) }));
};
export default LocationSelect;
